import { AxiosResponse } from 'axios'
import getService, { ApiConfig } from 'src/core/services/base'
import apiKey from 'src/core/services/base/apiKey'
import { responseProps } from './model'

const url = '/order/status/count'

export function getOrdersStatusCount(openUnAuthAlertMemo: () => void, web_order_status: string): Promise<AxiosResponse<responseProps>> {
  return getService<responseProps, ApiConfig<unknown>>(
    {
      config: {
        url,
        method: 'get',
        params: { web_order_status },
      },
      name: apiKey.getOrdersStatusCount,
    },
    openUnAuthAlertMemo,
  )
}
